import React, { useState, useContext } from "react";
import axios from "axios";
import { guestbookSites, environment } from "../../../settings/IntegrationConstants";
import {
  Header,
  Subheader,
  HeaderContainer,
  L300,
  InputItem,
  T300Large,
  InputSection,
  Input,
  InputErrorText,
  PrimaryButton,
} from "./SharedStyles";
import TermsPrivacy from "./TermsPrivacy";
import styled from "styled-components";
import { AuthContext } from "../AuthContext";
import OpenEye from "@/components/UI/Icons/OpenEye";
import ClosedEye from "@/components/UI/Icons/ClosedEye";
import WarningTriangle from "@/components/UI/Icons/WarningTriangle";
import I18n from "../../../translations/i18n";

const T300LargeSection = styled(T300Large)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const PasswordInputContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

const ToggleButton = styled.span`
  cursor: pointer;
  font-size: 0.875rem;
  color: #0077cc;
  margin-left: 8px;
  position: absolute;
  right: 10px;
`;

type PasswordProps = {
  firstName: string;
  email: string;
  onLoginClick: () => void;
  onForgotPassword: () => void;
  onSuccess: () => void;
};

const PasswordScreen = ({
  firstName,
  email,
  onLoginClick,
  onSuccess,
  onForgotPassword,
}: PasswordProps) => {
  const authContext: any = useContext(AuthContext);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(false)

  const onSubmitPassword = (e: React.FormEvent) => {
    e.preventDefault();
    setError(false)

    const submissionData = {
      email: email,
      wid: window.gb_data.widget.identifier,
      password: password,
    };

    axios
      .get(
        `${
          guestbookSites[environment as string].rewardsdash.url
        }/api/v1/bei/password_login`,
        { params: submissionData }
      )
      .then((response) => {
        if (response.status === 200) {
          localStorage.setItem("gb_storage_key", response.data.user_token);
          authContext.authenticate();
          onSuccess();
        } else {
          console.log(response);
        }
      })
      .catch((error) => {
        if (error.response?.data?.error === "Incorrect password") {
          setError(true)
        } else {
          console.log(error.response?.data?.error || error.message);
        }
      });
  };

  return (
    <form onSubmit={onSubmitPassword} style={{ width: "100%" }}>
      <HeaderContainer>
        <Header>{I18n.t(`views.hotel_integration.components.widget.mobile_modal.login.welcome_back`, {first_name: firstName})}</Header>
        <Subheader>{I18n.t(`views.hotel_integration.components.widget.mobile_modal.login.enter_password`)}</Subheader>
        <Subheader>
          <b>{email}</b>
        </Subheader>
      </HeaderContainer>

      <InputSection>
        <InputItem>
          <L300>{I18n.t(`views.hotel_integration.components.widget.mobile_modal.login.password`)}</L300>
          <PasswordInputContainer>
            <Input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.currentTarget.value)}
              required
              style={{ flex: 1 }}
              hasError={error}
            />
            <ToggleButton onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <ClosedEye/> : <OpenEye/>}
            </ToggleButton>
          </PasswordInputContainer>
          {error && 
            <InputErrorText>
              <WarningTriangle/>
              {I18n.t(`views.hotel_integration.components.widget.mobile_modal.login.password_warning`)}
            </InputErrorText>
          }
        </InputItem>
      </InputSection>

      <PrimaryButton type="submit">{I18n.t(`views.hotel_integration.components.widget.mobile_modal.buttons.login`)}</PrimaryButton>

      <T300LargeSection>
        <span onClick={onLoginClick}>{I18n.t(`views.hotel_integration.components.widget.mobile_modal.login.different_account`)}</span>
        <span onClick={onForgotPassword}>{I18n.t(`views.hotel_integration.components.widget.mobile_modal.login.forgot_password`)}</span>
      </T300LargeSection>

      <TermsPrivacy />
    </form>
  );
};

export default PasswordScreen;
